var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _path8, _path9, _ellipse, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgParty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 180,
    viewBox: "0 0 198 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9494 143.258C38.4634 145.446 32.4044 139.007 34.9817 132.666L61.4791 67.4707C63.6658 62.0906 70.676 60.7598 74.6822 64.9643L115.25 107.542C119.286 111.778 117.559 118.771 112.015 120.641L44.9494 143.258Z",
    fill: "url(#paint0_linear_1646_8524)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M134.852 2.34566C132.842 7.81779 135.988 13.3948 138.092 15.8497C138.263 16.0495 138.559 16.0661 138.78 15.9228C140.526 14.7898 143.643 14.306 145.762 14.1514C146.207 14.1189 146.433 13.5467 146.152 13.1997C143.148 9.49053 143.001 3.85508 143.4 0.760889C143.446 0.401326 143.119 0.0978121 142.767 0.18418L135.195 2.04157C135.038 2.08016 134.908 2.19361 134.852 2.34566Z",
    fill: "#42A4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.559 55.0882C112.669 54.3812 105.362 59.8336 102.306 63.0297C102.101 63.244 102.14 63.5849 102.357 63.787C104.232 65.533 105.352 69.2123 105.838 71.6361C105.924 72.0644 106.49 72.2199 106.791 71.9028C111.555 66.8763 119.901 64.93 124.242 64.5071C124.588 64.4735 124.803 64.1131 124.663 63.7955L120.964 55.3814C120.892 55.2177 120.737 55.1042 120.559 55.0882Z",
    fill: "#FF806F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M180 56.4077L181.644 63.3671L197.5 62.0476C196.396 59.0171 196.649 56.0866 196.914 55.0002L180 56.4077Z",
    fill: "#42A4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M172.995 79.7966L176.869 72.827L162.812 61.9998C161.445 65.3263 159.034 67.551 158 68.2476L172.995 79.7966Z",
    fill: "#FF806F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.22 98.5629L114.187 90.9537C121.506 86.3538 127.868 89.085 130.134 91.0255C138.292 98.0115 146.015 96.8413 148.857 95.383L149.362 102.094C143.654 108.252 134.2 102.707 130.186 99.1652C124.519 93.8065 117.18 96.5309 114.22 98.5629Z",
    fill: "#FFB72B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.37 8.24905L117.476 4.38106C110.249 8.36095 109.194 15.2168 109.569 18.1473C110.922 28.697 106.157 34.7557 103.606 36.4664L108.566 40.2877C116.199 38.481 116.612 27.5432 115.865 22.3001C114.533 14.7161 120.313 9.77272 123.37 8.24905Z",
    fill: "#FFB72B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.6569,
    cy: 21.6568,
    r: 4,
    transform: "rotate(44.8426 92.6569 21.6568)",
    fill: "#FF4B77"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 136.614,
    cy: 72.9049,
    r: 4.95019,
    transform: "rotate(44.8426 136.614 72.9049)",
    fill: "#FF4B77"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M84.7309 59.9923L85.5215 44.5786C88.1769 45.3722 92.0648 45.0049 93.6768 44.722C92.014 49.2747 92.1624 56.9912 92.4445 60.2803C91.0447 62.107 86.7189 60.8494 84.7309 59.9923Z",
    fill: "#42A4FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170 35.4996C155.2 33.8996 145.833 48.833 143 56.4996L137.5 54L143.5 44C153 29.9998 164 28.8392 170.5 29.9998C181.7 31.9996 183.5 28.4996 183 26.4996C182.2 19.2995 189.333 17.8329 193 17.9996V23.4998C188.2 23.0998 188 27.6665 188.5 29.9998C188.1 36.7998 176 36.4997 170 35.4996Z",
    fill: "#FFB72B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.0551,
    cy: 90.5637,
    rx: 37.6118,
    ry: 14.5,
    transform: "rotate(47.6457 90.0551 90.5637)",
    fill: "url(#paint1_linear_1646_8524)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1646_8524",
    x1: 79.5,
    y1: 102,
    x2: -47.5,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7575"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1646_8524",
    x1: 90.0551,
    y1: 76.0637,
    x2: 90.0551,
    y2: 105.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA4A4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgParty);
export default __webpack_public_path__ + "static/media/img_party.51aeb3431e34187f2c0039b9aff8496e.svg";
export { ForwardRef as ReactComponent };